export function isRetryableSyncError(error:unknown,online:boolean){
  if(!online)return true
  if(error instanceof TypeError)return true
  const value=error as {code?:string;message?:string}
  return !value.code&&/fetch|network|timeout|connection/i.test(value.message??'')
}
